'use client';

import TawkMessengerReact from '@tawk.to/tawk-messenger-react';

const TawkChat = () => {
    return (
        <TawkMessengerReact
            propertyId="688225f26cc5281929cb6aec"
            widgetId="1j0u68fi8"
        />
    );
};

export default TawkChat;